<template>
  <v-dialog
    v-model="dialog"
    scrollable
    :width="width"
    :disabled="disabled"
    :persistent="persistent"
    v-bind="{ fullscreen }"
    :content-class="contentClass"
    @input="inputEventHandler"
  >
    <template v-slot:activator="{ on }">
      <div
        v-show="isModalButtonVisible"
        class="show-modal-button-holder"
        v-on="on"
      >
        <naj-button
          v-if="buttonText"
          :disabled="disabled"
          :size="buttonSize"
          color="primary"
          class="show-modal-button"
          v-bind="{ outlined: buttonOutlined }"
        >
          {{ buttonText }}
        </naj-button>

        <slot
          v-show="!isModalButtonVisible"
          name="showButton"
        />
      </div>
    </template>

    <naj-box
      :no-header="!header"
      :title="title"
      :header-icon="closeButton ? 'mdi-close' : ''"
      :no-gutters="noGutters"
      :no-h-gutters="noHGutters"
      :no-v-gutters="noVGutters"
      :has-footer="footer || showFooterCloseButton"
      :no-bottom-margin="true"
      :inside-modal="true"
      :disable-collapsing="true"
      @iconClick="close"
    >
      <div
        v-if="!contentLoaded"
        class="loader"
      >
        <naj-loader></naj-loader>
      </div>
      <slot
        v-else
        :closeNajModal="close"
      />
      <template v-slot:footer>
        <div class="naj-modal-actions">
          <naj-button
            v-if="showFooterCloseButton"
            outlined
            @click="close"
          >
            {{
              local.common.close
            }}
          </naj-button>
          <slot
            name="actions"
            :closeNajModal="close"
          />
        </div>
      </template>
    </naj-box>
  </v-dialog>
</template>

<script>
export default {
  name: 'NajModal',
  props: {
    width: {
      required: false,
      default: 900,
    },
    header: {
      type: Boolean,
      default: true,
      required: false,
    },
    title: {
      type: String,
      required: false,
      default: '',
    },
    buttonText: {
      type: String,
      required: false,
    },
    buttonSize: {
      type: String,
      required: false,
    },
    footer: {
      type: Boolean,
      default: false,
      required: false,
    },
    closeButton: {
      type: Boolean,
      required: false,
      default: true,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
    noGutters: {
      type: Boolean,
      default: false,
      required: false,
    },
    noHGutters: {
      type: Boolean,
      default: false,
      required: false,
    },
    noVGutters: {
      type: Boolean,
      default: false,
      required: false,
    },
    persistent: {
      type: Boolean,
      default: false,
      required: false,
    },
    fullscreen: { required: false },
    showFooterCloseButton: {
      type: Boolean,
      default: false,
    },
    buttonOutlined: {
      type: Boolean,
      required: false,
      default: true,
    },
    contentClass: {
      type: String,
      required: false,
    },
    contentLoaded: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return { dialog: false };
  },
  computed: {
    isModalButtonVisible() {
      return this.$slots.showButton || this.buttonText;
    },
  },
  methods: {
    show() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.$emit('onClose');
    },
    inputEventHandler($event) {
      this.$emit('input', $event);
      !$event && this.$emit('onClose');
    },
  },
};
</script>

<style lang="scss" scoped>
.show-modal-button-holder {
  display: inline-block;
}
.naj-modal-actions {
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  display: flex;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  width: 100%;
  direction: initial;
}
::v-deep .close-modal-button {
  position: absolute;
  left: 10px;
  top: 0;
  bottom: 0;
  padding: 20px;
  border-right: 1px solid #f4f5f8;
  color: #d0021b;
}
.loader {
  padding: 30px 0;
}
</style>
